import { Box } from '@mui/material';
import ErrorPage from './ErrorPage';

export default function FallbackRender(error) {
  return (
    <Box sx={{ overflow: 'hidden', height: '100vh' }}>
      <ErrorPage error={error} />
    </Box>
  );
}
